import { ADVERTISEMENT_FIREPLACE, ADVERTISEMENT_HOME_BANNER, ADVERTISEMENT_INTERSCROLLER, ADVERTISEMENT_MAIN_SLIDER, ADVERTISEMENT_OVERVIEW_BANNER, ADVERTISEMENT_OVERVIEW_HERO } from "./constants/advertisementTypes";

const configAdvertisements = {
    images: {
        [ADVERTISEMENT_MAIN_SLIDER] : {
            desktop: {
                transId: "advertisement_image_desktop",
                width: 1920,
                height: 665,
                relativeTo: 1920
            },
            mobile: {
                transId: "advertisement_image_mobile",
                width: 770,
                height: 665,
                relativeTo: 1920
            }
        },
        [ADVERTISEMENT_OVERVIEW_HERO]: {
            desktop: {
                transId: "advertisement_image_desktop",
                width: 1920,
                height: 665,
                relativeTo: 1920
            },
            mobile: {
                transId: "advertisement_image_mobile",
                width: 770,
                height: 665,
                relativeTo: 1920
            }
        },
        [ADVERTISEMENT_OVERVIEW_BANNER]: {
            desktopOne: {
                transId: "advertisement_image_desktop_one",
                width: 1920,
                height: 120,
                relativeTo: 1920
            },
            desktopTwo: {
                transId: "advertisement_image_desktop_two",
                width: 855,
                height: 120,
                relativeTo: 1920
            },
            desktopThree: {
                transId: "advertisement_image_desktop_three",
                width: 655,
                height: 120,
                relativeTo: 1920
            },
            mobile: {
                transId: "advertisement_image_mobile",
                width: 770,
                height: 665,
                relativeTo: 1920
            },
        },
        [ADVERTISEMENT_HOME_BANNER]: {
            desktopOne: {
                transId: "advertisement_image_desktop_one",
                width: 1920,
                height: 450,
                relativeTo: 1920
            },
            desktopTwo: {
                transId: "advertisement_image_desktop_two",
                width: 855,
                height: 400,
                relativeTo: 1920
            },
            desktopThree: {
                transId: "advertisement_image_desktop_three",
                width: 655,
                height: 330,
                relativeTo: 1920
            },
            mobile: {
                transId: "advertisement_image_mobile",
                width: 770,
                height: 433,
                relativeTo: 1920
            },
        },
        [ADVERTISEMENT_INTERSCROLLER]: {
            mobile: {
                transId: "advertisement_image_mobile",
                width: 720,
                height: 1200,
                relativeTo: 1920
            }
        },
        [ADVERTISEMENT_FIREPLACE]: {
            desktop: {
                transId: "advertisement_image_desktop",
                width: 1920,
                height: 1234,
                relativeTo: 1920
            },
            desktopScrolled: {
                transId: "advertisement_image_desktop_scrolled",
                width: 1920,
                height: 120,
                relativeTo: 1920
            },
            mobile: {
                transId: "advertisement_image_mobile",
                width: 767,
                height: 700,
                relativeTo: 1920
            },
            mobileScrolled: {
                transId: "advertisement_image_mobile_scrolled",
                width: 767,
                height: 80,
                relativeTo: 1920
            }
        }
    }
}

export default configAdvertisements